import { Array, Intersect, Number, Record, Static, String, Boolean } from "runtypes";
import { TemplateRunType } from "./ITemplate";
import { IUser } from "./IUser";

// base without directors
export const SchoolBaseRunType = Record({
  logo1: String,
  logo2: String,
  name: String,
  primaryColor: String,
  secondaryColor: String,
  slug: String,
  tagline: String,
  templates: Array(TemplateRunType),
  mascot:String
});

// data you post/put
export const SchoolDataRunType = Intersect(
  SchoolBaseRunType,
  Record({
    directors: Array(
      Record({
        email: String,
        restrictedCoaches: Array(Number),
        firstName:String,
        lastName:String
      })
    ),
  })
);

// type I send to update
export interface ISchoolData extends Static<typeof SchoolDataRunType> {}

// data you would receive from server
export const SchoolRuntype = Intersect(
  SchoolBaseRunType,
  Record({
    id: Number,
    isAdSurvey: Boolean,
    ismidseason: Boolean,
    isEmbeddable: Boolean,
  })
);

// type received from server
export interface ISchool extends Static<typeof SchoolRuntype> {
  directors: IUser[];
  // mascot:string
}



// WEBPACK FOOTER //
// ./src/api/types/ISchool.ts